import React, { useEffect, useState } from "react";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";
import { Link } from "react-router-dom";

export default function SchemeReport() {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10);
    const [filterData, setFilterData] = useState({});
    const [downloadLoading, setDownloadLoading] = useState(false);

    // Image modal state
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    useEffect(() => {
        getReportData(
            {
                userId: "",
                mobile: "",
                start: "",
                end: "",
                schemeStart: "",
                schemeEnd: "",
                rewardStatus: "",
                schemeName: "",
            },
            1
        );
    }, []);

    // Function to open image modal
    const openImageModal = (imageUrl) => {
        setSelectedImage(imageUrl);
        setShowImageModal(true);
    };

    // Function to close image modal
    const closeImageModal = () => {
        setShowImageModal(false);
        setSelectedImage("");
    };

    const searchFormik = useFormik({
        initialValues: {
            userId: "",
            mobile: "",
            start: "",
            end: "",
            schemeStart: "",
            schemeEnd: "",
            rewardStatus: "",
            schemeName: "",
        },
        validate: (data) => {
            let errors = {};

            if (data.start && !data.end) {
                errors.end = "End date is required when start date is selected";
            }

            if (data.schemeStart && !data.schemeEnd) {
                errors.schemeEnd = "Scheme end date is required when scheme start date is selected";
            }

            if (data.mobile && data.mobile.length < 10) {
                errors.mobile = "Mobile must be 10 digits.";
            }

            if (data.userId && !/^\d+$/.test(data.userId)) {
                errors.userId = "User ID must be numeric.";
            }

            if (data.start && data.end && data.start > data.end) {
                errors.end = "End date should be greater than start date";
            }

            if (data.schemeStart && data.schemeEnd && data.schemeStart > data.schemeEnd) {
                errors.schemeEnd = "Scheme end date should be greater than scheme start date";
            }

            return errors;
        },
        onSubmit: (data) => {
            setCurrentPage(1);
            getReportData(data, 1);
            setFilterData(data);
        },
    });

    const isSearchFormFieldValid = (name) =>
        !!(searchFormik.touched[name] && searchFormik.errors[name]);

    const getSearchFormErrorMessage = (name) => {
        return (
            isSearchFormFieldValid(name) && (
                <small className="report-error-field">
                    {searchFormik.errors[name]}
                </small>
            )
        );
    };

    const getReportData = async (data, pageNum) => {
        setLoading(true);
        if (!token) {
            navigate("/");
        } else {
            const params = new URLSearchParams();

            if (data?.userId) params.append("userId", data.userId);
            if (data?.mobile) params.append("mobile", data.mobile);
            if (data?.schemeName) params.append("schemeName", data.schemeName);
            if (data?.rewardStatus) params.append("rewardStatus", data.rewardStatus);

            if (data?.start && data?.end) {
                params.append("start", moment(data.start).format("YYYY-MM-DD HH:mm:ss"));
                params.append("end", moment(data.end).format("YYYY-MM-DD 23:59:59"));
            }

            if (data?.schemeStart && data?.schemeEnd) {
                params.append("schemeStart", moment(data.schemeStart).format("YYYY-MM-DD HH:mm:ss"));
                params.append("schemeEnd", moment(data.schemeEnd).format("YYYY-MM-DD 23:59:59"));
            }

            params.append("sortBy", "uploaded_date_time");
            params.append("sortAsc", "true");
            params.append("limit", limit);
            params.append("page", pageNum);

            await axios
                .get(
                    Constants.baseUrl + `reports/schemeReport/list?${params.toString()}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Accept-Language": localStorage.getItem("langauge"),
                            appVersion: Constants.av,
                            platform: Constants.pt,
                            company: Constants.company,
                            program: Constants.program,
                        },
                    }
                )
                .then((res) => {
                    const dt = res.data;
                    if (dt.result === "success") {
                        setReportData(dt?.output?.results);
                        setTotalPages(dt?.output?.totalPages);
                    } else {
                        setReportData(null);
                        setTotalPages(0);
                    }
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    };

    const download = (data) => {
        setLoading(true);
        setDownloadLoading(true);
        try {
            const params = new URLSearchParams();

            if (data.userId) params.append("userId", data.userId);
            if (data.mobile) params.append("mobile", data.mobile);
            if (data.schemeName) params.append("schemeName", data.schemeName);
            if (data.rewardStatus) params.append("rewardStatus", data.rewardStatus);

            if (data.start && data.end) {
                params.append("start", moment(data.start).format("YYYY-MM-DD HH:mm:ss"));
                params.append("end", moment(data.end).format("YYYY-MM-DD 23:59:59"));
            }

            if (data.schemeStart && data.schemeEnd) {
                params.append("schemeStart", moment(data.schemeStart).format("YYYY-MM-DD HH:mm:ss"));
                params.append("schemeEnd", moment(data.schemeEnd).format("YYYY-MM-DD 23:59:59"));
            }

            axios
                .get(
                    Constants.baseUrl + `reports/download/schemeReport?${params.toString()}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Accept-Language": localStorage.getItem("langauge"),
                            appVersion: Constants.av,
                            platform: Constants.pt,
                            company: Constants.company,
                            program: Constants.program,
                        },
                        responseType: "blob",
                    }
                )
                .then((res) => {
                    if (res.status === 200) {
                        const fileData = new Blob([res.data], { type: "text/csv" });
                        saveAs(fileData, "scheme_report.csv");
                    } else {
                        swal({
                            text: res.data.msg,
                            timer: 2000,
                            buttons: false,
                        });
                    }
                    setLoading(false);
                    setDownloadLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    setDownloadLoading(false);
                });
        } catch (error) {
            console.log(error);
            setLoading(false);
            setDownloadLoading(false);
        }
    };

    const rewardStatusOptions = [
        { value: "", label: "All Status" },
        { value: "PENDING", label: "PENDING" },
        { value: "SETTLED", label: "SETTLED" },
    ];

    return (
        <>
            {loading ? <Oval /> : null}
            <Navbar />
            <section className="page-content--bge55">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h3 className="head1">Scheme Report</h3>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={searchFormik.handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                                        <div className="row">
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control reset"
                                                        type="text"
                                                        placeholder="User ID"
                                                        id="userId"
                                                        value={searchFormik.values.userId}
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value.replace(/\D/g, "");
                                                            searchFormik.handleChange({
                                                                target: {
                                                                    name: "userId",
                                                                    value: numericValue,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                    {getSearchFormErrorMessage("userId")}
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control reset"
                                                        type="text"
                                                        placeholder="Mobile No."
                                                        id="mobile"
                                                        value={searchFormik.values.mobile}
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value
                                                                .replace(/\D/g, "")
                                                                .slice(0, 10);
                                                            searchFormik.handleChange({
                                                                target: {
                                                                    name: "mobile",
                                                                    value: numericValue,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                    {getSearchFormErrorMessage("mobile")}
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control reset"
                                                        type="text"
                                                        placeholder="Scheme Name"
                                                        id="schemeName"
                                                        value={searchFormik.values.schemeName}
                                                        onChange={searchFormik.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <select
                                                        className="form-control reset"
                                                        id="rewardStatus"
                                                        value={searchFormik.values.rewardStatus}
                                                        onChange={searchFormik.handleChange}
                                                    >
                                                        {rewardStatusOptions.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12 mt-3">
                                                <DatePicker
                                                    id="start"
                                                    selected={searchFormik.values.start}
                                                    onChange={(date) =>
                                                        searchFormik.setFieldValue("start", date)
                                                    }
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    maxDate={new Date()}
                                                    placeholderText="Start Date"
                                                />
                                                {getSearchFormErrorMessage("start")}
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12 mt-3">
                                                <DatePicker
                                                    id="end"
                                                    selected={searchFormik.values.end}
                                                    onChange={(date) =>
                                                        searchFormik.setFieldValue("end", date)
                                                    }
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    minDate={searchFormik.values.start || null}
                                                    maxDate={new Date()}
                                                    placeholderText="End Date"
                                                />
                                                {getSearchFormErrorMessage("end")}
                                            </div>
                                            {/* <div className="col-md-3 col-sm-12 col-xs-12 mt-3">
                                                <DatePicker
                                                    id="schemeStart"
                                                    selected={searchFormik.values.schemeStart}
                                                    onChange={(date) =>
                                                        searchFormik.setFieldValue("schemeStart", date)
                                                    }
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    placeholderText="Scheme Start Date"
                                                />
                                                {getSearchFormErrorMessage("schemeStart")}
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12 mt-3">
                                                <DatePicker
                                                    id="schemeEnd"
                                                    selected={searchFormik.values.schemeEnd}
                                                    onChange={(date) =>
                                                        searchFormik.setFieldValue("schemeEnd", date)
                                                    }
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    minDate={searchFormik.values.schemeStart || null}
                                                    placeholderText="Scheme End Date"
                                                />
                                                {getSearchFormErrorMessage("schemeEnd")}
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                        <div className="d-flex justify-content-between mt-3">
                                            <button
                                                type="submit"
                                                className="btn btn-primary report-submit-button"
                                            >
                                                Search
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-primary report-submit-button"
                                                onClick={() => {
                                                    setFilterData({});
                                                    setCurrentPage(1);
                                                    searchFormik.resetForm();
                                                    getReportData(
                                                        {
                                                            userId: "",
                                                            mobile: "",
                                                            start: "",
                                                            end: "",
                                                            schemeStart: "",
                                                            schemeEnd: "",
                                                            rewardStatus: "",
                                                            schemeName: "",
                                                        },
                                                        1
                                                    );
                                                }}
                                            >
                                                Reset
                                            </button>

                                            {reportData && reportData.length > 0 && (
                                                <Link
                                                    to="#"
                                                    className={`btn btn-primary report-submit-button mx-5 ${downloadLoading ? "btn-opacity" : ""}`}
                                                    onClick={() => download(searchFormik.values)}
                                                >
                                                    {downloadLoading ? (
                                                        <span>
                                                            <i className="fa fa-spinner fa-spin"></i> Export
                                                        </span>
                                                    ) : (
                                                        " Export"
                                                    )}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="row mt-20">
                                <div className="col-md-12">
                                    <div className="table-responsive table--no-card">
                                        <table className="table table-borderless table-striped table-earning">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>User ID</th>
                                                    <th>Mobile Number</th>
                                                    <th>User Name</th>
                                                    <th>Scheme ID</th>
                                                    <th>Scheme Name</th>
                                                    <th>Scheme Category</th>
                                                    <th>Scheme Details</th>
                                                    <th>Scheme Start Date</th>
                                                    <th>Scheme End Date</th>
                                                    <th>Created Date</th>
                                                    <th>Reward Image</th>
                                                    <th>Reward Name</th>
                                                    <th>Reward Status</th>
                                                    <th>User Confirmation Status</th>
                                                    <th>User Confirmation Date</th>
                                                </tr>
                                            </thead>
                                            {!reportData || reportData.length === 0 ? (
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            colSpan="15"
                                                            style={{ textAlign: "center", fontSize: "16px" }}
                                                        >
                                                            No record found!
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    {reportData.map((item, index) => {
                                                        const serialNumber =
                                                            (currentPage - 1) * limit + index + 1;
                                                        return (
                                                            <tr key={index}>
                                                                <td>{serialNumber}</td>
                                                                <td>{item[0] || ""}</td>
                                                                <td>{item[1] || ""}</td>
                                                                <td>{item[2] || ""}</td>
                                                                <td>{item[3] || ""}</td>
                                                                <td>{item[4] || ""}</td>
                                                                <td>{item[5] || ""}</td>
                                                                <td>{item[6] || ""}</td>
                                                                <td>{item[7] || ""}</td>
                                                                <td>{item[8] || ""}</td>
                                                                <td>{item[9] || ""}</td>
                                                                <td>
                                                                    {item[11] ? (
                                                                        <img
                                                                            src={item[11]}
                                                                            alt="Reward"
                                                                            style={{
                                                                                width: "80px",
                                                                                height: "50px",
                                                                                objectFit: "cover",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                openImageModal(item[11]);
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </td>
                                                                <td>{item[10] || ""}</td>
                                                                <td>{item[12] || ""}</td>
                                                                <td>{item[13] || ""}</td>
                                                                <td>{item[14] || ""}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            )}
                                        </table>
                                        {totalPages > 1 && (
                                            <ResponsivePagination
                                                current={currentPage}
                                                total={totalPages}
                                                onPageChange={(page) => {
                                                    setCurrentPage(page);
                                                    getReportData(filterData, page);
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Image Modal */}
            {showImageModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        background: "rgba(0,0,0,0.8)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 99999,
                    }}
                    onClick={closeImageModal}
                >
                    <div
                        style={{
                            position: "relative",
                            maxWidth: "90%",
                            maxHeight: "90%",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={closeImageModal}
                            style={{
                                position: "absolute",
                                top: "-15px",
                                right: "-15px",
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                                border: "none",
                                background: "#fff",
                                cursor: "pointer",
                                fontSize: "18px",
                                fontWeight: "bold",
                                zIndex: 2,
                            }}
                        >
                            ×
                        </button>

                        <img
                            src={selectedImage}
                            alt="Reward Full View"
                            style={{
                                width: "100%",
                                maxWidth: "700px",
                                maxHeight: "85vh",
                                objectFit: "contain",
                                borderRadius: "10px",
                                background: "#fff",
                                padding: "10px",
                            }}
                        />
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
}